export enum DeviceTypes {
  BARRIERS = 'BARRIERS',
  CAMERA = 'CAMERA',
  CAMERA_SERVER = 'CAMERA_SERVER',
  DEPOSITOR = 'DEPOSITOR',
  DETECTOR = 'DETECTOR',
  DOORS = 'DOORS',
  ENGINE = 'ENGINE',
  IKSORIS_PARKING_TICKET_CASH_MACHINE = 'IKSORIS_PARKING_TICKET_CASH_MACHINE',
  IKSORIS_PARKING_TICKET_CASHLESS_MACHINE = 'IKSORIS_PARKING_TICKET_CASHLESS_MACHINE',
  OFFLINE_SERVER = 'OFFLINE_SERVER',
  PALM = 'PALM',
  PASSAGE = 'PASSAGE',
  SELFPOS_ACCESS_TICKET_CASHLESS_MACHINE = 'SELFPOS_ACCESS_TICKET_CASHLESS_MACHINE',
  TERMINALS = 'TERMINALS',
}
